import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
    pagingVoucherCategory,
    getVoucherCategoryById,
    saveVoucherCategory,
    deleteVoucherCategory
} from 'app/services/VoucherCategoryService';

import { VoucherCategory } from "app/common/Model/VoucherCategory";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";
import i18n from 'i18n';

export default class VoucherCategoryStore {
    listAllVoucherCategory = [];
    searchVoucherCategory = new SearchObject();
    pageVoucherCategory = null;
    selectedVoucherCategory = null;
    openFormCreateOrEdit = false;
    openConfirmDeleteVoucherCategory = false;

    constructor() {
        makeAutoObservable(this);
    }

    pagingVoucherCategory = async () => {
        return await pagingVoucherCategory(this.searchVoucherCategory)
            .then(({ data }) => {
                this.pageVoucherCategory = data;
            })
            .catch((error) => {
                console.error(error);
                toast.error("Lấy dữ liệu hạng mục voucher có lỗi");
            })
    }

    handleChangeFormSearch = (searchVoucherCategory) => {
        this.searchVoucherCategory = checkSearchObject(this.searchVoucherCategory, searchVoucherCategory);
        this.pagingVoucherCategory();
    }

    handleOpenFormCreateOrEdit = (voucherCategoryId) => {
        if (Boolean(voucherCategoryId)) {
            getVoucherCategoryById(voucherCategoryId)
                .then(({ data }) => {
                    this.selectedVoucherCategory = data;
                    this.openFormCreateOrEdit = true;
                }).catch(function (error) {
                    console.error(error);
                    toast.error(i18n.t("management.voucherCategory.getDataFail"));
                });
        } else {
            this.selectedVoucherCategory = new VoucherCategory();
            this.openFormCreateOrEdit = true;
        }
    }

    saveVoucherCategory = async (voucherCategory, { setSubmitting }) => {
        return await saveVoucherCategory(voucherCategory).then(() => {
            this.selectedVoucherCategory = null;
            toast.success(i18n.t("management.voucherCategory.saveSuccess"));
            this.pagingVoucherCategory();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.voucherCategory.saveFail"));
        }).finally(function () {
            setSubmitting(false);
        });
    }

    handleDeleteVoucherCategory = (voucherCategory) => {
        this.selectedVoucherCategory = { id: voucherCategory?.id };
        this.openConfirmDeleteVoucherCategory = true;
    }

    handleConfirmDeleteVoucherCategory = () => deleteVoucherCategory(this.selectedVoucherCategory?.id)
        .then(() => {
            if (this.searchVoucherCategory.pageIndex > 1 && this.pageVoucherCategory?.content?.length === 1) {
                this.searchVoucherCategory.pageIndex -= 1;
            }
            toast.success(i18n.t("management.voucherCategory.deleteSuccess"));
            this.pagingVoucherCategory();
            this.handleClosePopup();
        }).catch(function (error) {
            console.error(error);
            toast.error(i18n.t("management.voucherCategory.deleteFail"));
        })

    handleClosePopup = () => {
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteVoucherCategory = false;
    }

    resetStore = () => {
        this.searchVoucherCategory = new SearchObject();
        this.pageVoucherCategory = null;
        this.selectedVoucherCategory = null;
        this.openFormCreateOrEdit = false;
        this.openConfirmDeleteVoucherCategory = false;
    }
}
